import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ActivityNotificationService } from '../../shared/activity-notification/activity-notification.service';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { OeAppService } from '../../shared/oe-app.service';
import { OneSignalService } from '../../shared/one-signal.service';
import { ProgressResultDto } from '../../shared/types/ProgressResultDto';
import { StudyBundleCourseDto } from '../../shared/types/StudyBundleCourseDto';
import { AnalyticsOutcomeEvents } from '../../shared/types/analytics-outcome.types';

@Injectable({
  providedIn: 'root',
})
export class LessonCarouselService {
  constructor(
    private oeAppService: OeAppService,
    private oeAppPersonService: OeAppPersonService,
    private http: HttpClient,
    private activityNotificationService: ActivityNotificationService,
    private oneSignalService: OneSignalService
  ) {}

  public getLessons(unitId?: number): Observable<Array<StudyBundleCourseDto>> {
    const url = `${this.oeAppService.courseServiceHost}/v1/lessons?contactId=${
      this.oeAppPersonService.contactId
    }&lessonType=${this.oeAppPersonService.lessonType}${unitId ? '&unitId=' + unitId : ''}`;
    return this.http.get<Array<StudyBundleCourseDto>>(url).pipe(catchError(() => of(null)));
  }

  getCurrentMiniLesson(lesssonType: StudyBundleCourseDto['lessonType']): Observable<StudyBundleCourseDto> {
    const url = `${this.oeAppService.courseServiceHost}/v1/lessons/current-lesson?contactId=${this.oeAppPersonService.contactId}&lessonType=${lesssonType}`;

    return this.http.get<StudyBundleCourseDto>(url);
  }

  getMiniLesson({ courseId, unitId }: { courseId: number; unitId: number }) {
    return this.getLessons(unitId).pipe(
      map((courses: StudyBundleCourseDto[]) => courses.find((course) => course.id === courseId))
    );
  }

  initCourse(courseId: number) {
    const personId = this.oeAppPersonService.id;
    this.http
      .put<void>(`${this.oeAppService.oeProgressServiceHost}/v1/progress/init/lesson/${personId}/${courseId}`, null)
      .subscribe();
  }

  completeLesson(courseId: number) {
    return this.http
      .post<ProgressResultDto>(
        `${this.oeAppService.oeProgressServiceHost}/v1/progress/finalize/lesson/${this.oeAppPersonService.id}/${courseId}`,
        null
      )
      .pipe(
        map((data: ProgressResultDto) => {
          this.activityNotificationService.activityCompleted(
            {
              points: data.awardedPoints,
              badges: data.awardedBadges,
              overTheLimitActivity: data.overTheLimitActivity,
            },
            true,
            false
          );

          this.oneSignalService.trackOutcome(AnalyticsOutcomeEvents.LAST_LESSON_COMPLETED);
          return data;
        })
      );
  }

  finishAssessment(courseId: number): Observable<any> {
    const successfulAssessmentResultDto = {
      questions: [{ answer: 'UNKNOWN', key: 'UNKNOWN', correct: true }],
    };

    return this.http.post(`/course/assessment/${courseId}`, successfulAssessmentResultDto);
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/lesson-carousel/lesson-carousel.service.ts